webpackJsonp([138584234813021],{

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.77bc9ec1.jpg";

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/impact.767f1929.png";

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/inclusion.beb0396e.png";

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/innovation.92a09d58.png";

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/john.15d64f55.png";

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AwardCeremonyPage;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _TitleSection = __webpack_require__(19);
	
	var _TitleSection2 = _interopRequireDefault(_TitleSection);
	
	var _MaxWidthContainer = __webpack_require__(10);
	
	var _Sessions = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var coverImage = __webpack_require__(553);
	var innovationImage = __webpack_require__(556);
	var impactImage = __webpack_require__(554);
	var inclusionImage = __webpack_require__(555);
	var johnImage = __webpack_require__(557);
	
	function AwardCeremonyPage() {
	  return React.createElement(
	    'main',
	    null,
	    React.createElement(
	      _TitleSection2.default,
	      null,
	      React.createElement(
	        _MaxWidthContainer.RunningTextContainer,
	        null,
	        React.createElement(
	          _Sessions.Title,
	          null,
	          'Gala Case Awards'
	        ),
	        React.createElement(
	          _Sessions.Row,
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Galaxy 2019 will culminate in our annual case awards ceremony recognizing exemplary sustainability case studies, published over the past year on the Gala platform, that stand out for their contribution to the areas of Innovation, Inclusion, and Impact. Join us as last year\u2019s winners present the award in their category \u2013 especially if you\u2019ve used Gala to publish a case this year!'
	          ),
	          React.createElement(_Sessions.Image, { src: coverImage })
	        )
	      )
	    ),
	    React.createElement(
	      _MaxWidthContainer.RunningTextContainer,
	      null,
	      React.createElement(
	        'h2',
	        null,
	        'Ceremony Hosts'
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Presenting the Award for Innovation'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Last year\u2019s winners,',
	            ' ',
	            React.createElement(
	              'a',
	              { href: 'https://www.learngala.com/cases/ewaste-in-ghana' },
	              'Electronic Graveyard: What is the solution to Ghana\u2019s e-waste dilemma?'
	            ),
	            ' ',
	            'by Anne Canavati, Jayson Toweh, Adam Simon, & Brian Arbic'
	          )
	        ),
	        React.createElement(_Sessions.Image, { src: innovationImage })
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Presenting the Award for Inclusion'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Last year\u2019s winners,',
	            ' ',
	            React.createElement(
	              'a',
	              { href: 'https://www.learngala.com/cases/mi-wolves' },
	              'Wolf Wars: Should we hunt gray wolves in Michigan?'
	            ),
	            ' ',
	            'by Steven Yaffee, Julia Wondolleck, David Wang, & Sheena Vanleuven'
	          )
	        ),
	        React.createElement(_Sessions.Image, { src: inclusionImage })
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Presenting the Award for Impact'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Last year\u2019s winners,',
	            ' ',
	            React.createElement(
	              'a',
	              { href: 'https://www.learngala.com/cases/motown-farming' },
	              'Farming in Motown: Is the future of Detroit food provisioning and access home-grown?'
	            ),
	            ' ',
	            'by Lauren Boone, Liz Ultee, Arun Agrawal, Joshua Newell, K. Arthur Endsley, Benjamin Goldstein, and Summer Aldred'
	          )
	        ),
	        React.createElement(_Sessions.Image, { src: impactImage })
	      )
	    ),
	    React.createElement(
	      _MaxWidthContainer.RunningTextContainer,
	      null,
	      React.createElement(
	        'h2',
	        null,
	        'John Leyland, Sculpture Artist'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'p',
	          null,
	          'Galaxy\u2019s beautiful ceramic awards are works by John Leyland (pictured left), local sculpture artist and ceramics studio coordinator at the Stamps School of Art & Design. John is a sustainability practitioner himself, having contributed his expertise in the building of cleaner burning cookstoves in Gabon & Uganda, as well as the creation of ceramic water filters with partners in Nepal & Cuba.'
	        ),
	        React.createElement(_Sessions.Image, { src: johnImage })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sessions-awards-ceremony-js-a77e85a07c1598573742.js